import {Component, Input, OnInit} from '@angular/core';
import {NgbModal, NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";
import {SearchVendorService} from "../../services/search-vendor.service"; 
import {SearchVendorDto} from "../../../auto-generated-server-dtos/adjuster/configuration/search-vendor-dto";
import {SearchRepairCentreService} from "../../services/search-repair-centre.service";
import {SearchRepairCentreDto} from "../../../auto-generated-server-dtos/adjuster/configuration/search-repair-centre-dto";
import {NgForOf, NgIf} from "@angular/common";
import {EditConfigurationModalComponent} from "../edit-configuration-modal/edit-configuration-modal.component";
import Utils from "../../../helpers/utils";

@Component({
  selector: 'app-search-modal',
  standalone: true,
  imports: [
    NgIf,
    NgForOf
  ],
  templateUrl: './search-modal.component.html',
  styleUrl: './search-modal.component.scss'
})
export class SearchModalComponent implements OnInit {
  @Input() public searchType: string = '';
  
  public modalTitle: string = '';
  public searchLabel: string = '';
  
  public vendorSearchResults: SearchVendorDto[] = [];
  public repairCentreSearchResults: SearchRepairCentreDto[] = [];
  
  
  constructor(
      private modal: NgbModal,
      private activeModal: NgbActiveModal,
      private searchVendorService: SearchVendorService,
      private searchRepairCentreService: SearchRepairCentreService,
  ) {
  }  
  
  ngOnInit() {
    switch (this.searchType) {
      case 'vendor':
        this.modalTitle = 'Search for a Dealer';
        this.searchLabel = 'Dealership';
        break;
      case 'repairCentre':
        this.modalTitle = 'Search for a Repair Center';
        this.searchLabel = 'Repair Center';
        break;    
      default:
        throw new Error('Invalid search type.');
    }
    document.getElementById("searchField")?.focus();
  }

  closeSearchModal(): void {
    this.activeModal.close();
  }
  
  doSearch(event: any): void {
    const searchTerm = event.target.value;
    
    if (this.searchType === 'vendor') {
      this.searchVendorService.searchVendor(searchTerm).subscribe((results: SearchVendorDto[]) => {
        this.vendorSearchResults = results;
      });
    }

    if (this.searchType === 'repairCentre') {
      this.searchRepairCentreService.searchRepairCentre(searchTerm).subscribe((results: SearchRepairCentreDto[]) => {
        this.repairCentreSearchResults = results;
      });
    }    
  }
  
  selectVendor(selectedVendor: SearchVendorDto): void {
    const modalRef = this.modal.open(EditConfigurationModalComponent);
    modalRef.componentInstance.modalType = 'vendor';
    modalRef.componentInstance.vendor = selectedVendor;
    this.activeModal.close();
  }

  selectRepairCentre(selectedRepairCentre: SearchRepairCentreDto): void {
    const modalRef = this.modal.open(EditConfigurationModalComponent);
    modalRef.componentInstance.modalType = 'repairCentre';
    modalRef.componentInstance.repairCentre = selectedRepairCentre;
    this.activeModal.close();
  }

  protected readonly Utils = Utils;
}
